import {
  AspectRatio,
  Avatar,
  Box,
  Flex,
  SlideFade,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useState } from 'react'
import { GenerateImageResponse } from '../../../interfaces'
import ExpandImageModal from './ExpandImageModal'
import ImageWithRetry from './ImageWithRetry'

interface HistoryImagePreviewProps {
  onOpen: () => void
  setCurrentIndex: (index: number) => void
  generatedImages: GenerateImageResponse[]
  index: number
}

const HistoryImagePreview = ({
  onOpen,
  setCurrentIndex,
  generatedImages,
  index,
}: HistoryImagePreviewProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isImageLoaded, setIsImageLoaded] = useState<boolean>(false)

  return (
    <>
      <Box
        position="relative"
        overflow="hidden"
        borderRadius="8px"
        cursor={isImageLoaded ? 'pointer' : 'default'}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => {
          if (isImageLoaded) {
            setCurrentIndex(index)
            onOpen()
          }
        }}
      >
        <AspectRatio ratio={1} width="100%">
          <ImageWithRetry
            src={generatedImages[index].url}
            setIsImageLoaded={setIsImageLoaded}
          />
        </AspectRatio>
        {isImageLoaded && (
          <>
            <Box
              position="absolute"
              top="0"
              left="0"
              width="100%"
              height="100%"
              bg="linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2))"
              borderRadius="inherit"
              opacity={isHovered ? 1 : 0}
              transition="opacity 0.5s ease-in-out"
            />
            <SlideFade in={isHovered} unmountOnExit>
              <Box position="absolute" left="24px" right="24px" bottom="16px">
                <Text fontSize="16px" color="white" mb="16px">
                  {generatedImages[index].prompt}
                </Text>
                <Flex gap="8px" align="center">
                  <Avatar
                    size="xs"
                    name={generatedImages[index].createdBy.name}
                  />
                  <Text fontSize="12px" fontWeight="500" color="white">
                    {generatedImages[index].createdBy.name}
                  </Text>
                </Flex>
              </Box>
            </SlideFade>
          </>
        )}
      </Box>
    </>
  )
}

export default HistoryImagePreview
